import React from 'react'
import { Moon, Sun, Monitor } from 'lucide-react'
import { useTheme } from 'next-themes'
import { useDispatch } from 'react-redux'
import { setTheme as setReduxTheme } from 'src/store'
import { Button } from 'src/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()
  const dispatch = useDispatch()

  const toggleTheme = () => {
    let newTheme
    if (theme === 'light') {
      newTheme = 'dark'
    } else if (theme === 'dark') {
      newTheme = 'system'
    } else {
      newTheme = 'light'
    }
    setTheme(newTheme)
    dispatch(setReduxTheme(newTheme))
  }

  const getThemeLabel = () => {
    if (theme === 'light') return 'Light mode'
    if (theme === 'dark') return 'Dark mode'
    return 'System mode'
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            <Sun className="h-5 w-5 rotate-0 scale-100 transition-all data-[theme=dark]:rotate-90 data-[theme=dark]:scale-0 data-[theme=system]:rotate-90 data-[theme=system]:scale-0"
                 data-theme={theme} />
            <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all data-[theme=dark]:rotate-0 data-[theme=dark]:scale-100 data-[theme=system]:rotate-90 data-[theme=system]:scale-0"
                  data-theme={theme} />
            <Monitor className="absolute h-5 w-5 rotate-90 scale-0 transition-all data-[theme=system]:rotate-0 data-[theme=system]:scale-100"
                     data-theme={theme} />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{getThemeLabel()}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default ThemeToggle
